/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
import { FxIdWebFeaturesProfileGetTwitchGameDataFromJSON, FxIdWebFeaturesProfileGetTwitchGameDataToJSON, } from './FxIdWebFeaturesProfileGetTwitchGameData';
/**
 * Check if a given object implements the FxIdWebFeaturesProfileGetTwitchData interface.
 */
export function instanceOfFxIdWebFeaturesProfileGetTwitchData(value) {
    return true;
}
export function FxIdWebFeaturesProfileGetTwitchDataFromJSON(json) {
    return FxIdWebFeaturesProfileGetTwitchDataFromJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileGetTwitchDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'TwitchGameData': json['TwitchGameData'] == null ? undefined : (mapValues(json['TwitchGameData'], FxIdWebFeaturesProfileGetTwitchGameDataFromJSON)),
    };
}
export function FxIdWebFeaturesProfileGetTwitchDataToJSON(json) {
    return FxIdWebFeaturesProfileGetTwitchDataToJSONTyped(json, false);
}
export function FxIdWebFeaturesProfileGetTwitchDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'TwitchGameData': value['TwitchGameData'] == null ? undefined : (mapValues(value['TwitchGameData'], FxIdWebFeaturesProfileGetTwitchGameDataToJSON)),
    };
}
//# sourceMappingURL=FxIdWebFeaturesProfileGetTwitchData.js.map